const DITypes = {
  SocketConnection: Symbol('SocketConnection'),
  SocketAdapter: Symbol('SocketAdapter'),
  DispatcherFactory: Symbol('DispatcherFactory'),
  SocketClient: Symbol('SocketClient'),
  SocketDispatcher: Symbol('SocketDispatcher'),
};

export default DITypes;
